import { Coordinates } from './GoogleMapsRoute';

export const GEOCODING_STATUS_OK = 'OK';

export type GeocodeResult = {
  coords: Coordinates;
  formattedAddress: string;
};

export type GeocodeCallback = {
  onSuccess: (
    coords: Coordinates,
    formattedAddress: string,
    type: 'start' | 'end',
  ) => void;
  onError?: (error: Error) => void;
};

export class GeocoderService {
  private geocoder: any | null = null;

  private getGeocoder(): any | null {
    if (
      !this.geocoder &&
      typeof window !== 'undefined' &&
      window.google?.maps
    ) {
      this.geocoder = new window.google.maps.Geocoder();
    }
    return this.geocoder;
  }

  isAvailable(): boolean {
    return (
      typeof window !== 'undefined' &&
      !!window.google?.maps &&
      !!this.getGeocoder()
    );
  }

  geocode(
    address: string,
    type: 'start' | 'end',
    callback: GeocodeCallback,
  ): void {
    if (!address.trim() || !this.isAvailable()) {
      return;
    }

    const geocoder = this.getGeocoder();
    if (!geocoder) {
      if (callback.onError) {
        callback.onError(new Error('Geocoder not available'));
      }
      return;
    }

    try {
      geocoder.geocode({ address }, (results: unknown, status: unknown) => {
        if (
          status === GEOCODING_STATUS_OK &&
          results &&
          Array.isArray(results) &&
          results.length > 0
        ) {
          const firstResult = results[0] as {
            geometry: { location: { lat: () => number; lng: () => number } };
            formatted_address: string;
          };
          const location = firstResult.geometry.location;
          const coords: Coordinates = {
            lat: location.lat(),
            lng: location.lng(),
          };
          const formattedAddress = firstResult.formatted_address;
          callback.onSuccess(coords, formattedAddress, type);
        } else if (callback.onError) {
          callback.onError(
            new Error(`Geocoding failed with status: ${String(status)}`),
          );
        }
      });
    } catch (err) {
      if (callback.onError) {
        callback.onError(
          err instanceof Error ? err : new Error('Geocoding failed'),
        );
      }
    }
  }
}
